import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { StablecoinCurrency } from '@40seas/models';
import { z } from 'zod';

export const StableCoinPaymentMethodSchema = z.object({
    walletAddress: z.string(),
    network: z.string(),
    currency: EnumSchema(StablecoinCurrency),
});

export class StableCoinPaymentMethod extends FromSchema(StableCoinPaymentMethodSchema) {
    walletAddress: string;
    network: string;
    currency: StablecoinCurrency;
}
